/* clone-rv-pdp-main: gallery, chọn gói (bundle), dropdown biến thể, thêm giỏ nhiều dòng, accordion, cuộn tới neo. */
(function () {
  function initGallery(root) {
    const gallery = root.querySelector('[data-gallery]');
    if (!gallery) return;
    const track = gallery.querySelector('[data-track]');
    const thumbs = gallery.querySelector('[data-thumbs]');
    const prev = gallery.querySelector('[data-prev]');
    const next = gallery.querySelector('[data-next]');
    const slides = track ? Array.from(track.children) : [];
    if (!track || slides.length === 0) return;
    let active = 0;
    let scrollTimer = null;

    const step = () => {
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    };

    const setActive = (i) => {
      active = Math.max(0, Math.min(slides.length - 1, i));
      if (thumbs) {
        thumbs.querySelectorAll('[data-thumb]').forEach((t, idx) => {
          const on = idx === active;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-current', on ? 'true' : 'false');
          if (on) {
            const left = t.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - t.offsetWidth) / 2;
            thumbs.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
          }
        });
      }
      if (prev) prev.classList.toggle('is-disabled', active === 0);
      if (next) next.classList.toggle('is-disabled', active === slides.length - 1);
    };

    const goTo = (i) => {
      const target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: target * step(), behavior: 'smooth' });
      setActive(target);
    };

    track.addEventListener(
      'scroll',
      () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const i = Math.round(track.scrollLeft / step());
          if (i !== active) setActive(i);
        }, 60);
      },
      { passive: true }
    );

    if (thumbs) {
      thumbs.addEventListener('click', (e) => {
        const t = e.target.closest('[data-thumb]');
        if (t) goTo(parseInt(t.dataset.thumb, 10));
      });
    }
    if (prev) prev.addEventListener('click', () => goTo(active - 1));
    if (next) next.addEventListener('click', () => goTo(active + 1));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(active - 1);
      if (e.key === 'ArrowRight') goTo(active + 1);
    });
    setActive(0);
  }

  function closeAllLists(root, except) {
    root.querySelectorAll('[data-vsel]').forEach((sel) => {
      if (sel === except) return;
      const list = sel.querySelector('[data-vlist]');
      const btn = sel.querySelector('[data-vbtn]');
      if (list) list.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function initBundles(root) {
    const bundles = Array.from(root.querySelectorAll('[data-bundle]'));
    const mainId = root.querySelector('[data-main-id]');

    const syncMainId = () => {
      const sel = root.querySelector('[data-bundle].is-selected [data-variant-row]');
      if (sel && mainId) mainId.value = sel.dataset.variantId;
    };

    const select = (bundle) => {
      bundles.forEach((b) => b.classList.toggle('is-selected', b === bundle));
      const radio = bundle.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      closeAllLists(root);
      syncMainId();
    };

    bundles.forEach((b) => {
      const radio = b.querySelector('input[type="radio"]');
      if (radio) radio.addEventListener('change', () => radio.checked && select(b));
    });

    // Dropdown biến thể (giống dropdown của Kaching)
    root.querySelectorAll('[data-vsel]').forEach((sel) => {
      const btn = sel.querySelector('[data-vbtn]');
      const list = sel.querySelector('[data-vlist]');
      const row = sel.closest('[data-variant-row]');
      if (!btn || !list || !row) return;
      const options = Array.from(list.querySelectorAll('[role="option"]'));

      const open = () => {
        closeAllLists(root, sel);
        list.hidden = false;
        btn.setAttribute('aria-expanded', 'true');
        const cur = list.querySelector('[aria-selected="true"]') || options[0];
        if (cur) cur.focus({ preventScroll: true });
      };
      const close = (focusBtn) => {
        list.hidden = true;
        btn.setAttribute('aria-expanded', 'false');
        if (focusBtn) btn.focus();
      };
      const choose = (opt) => {
        if (!opt || opt.getAttribute('aria-disabled') === 'true') return;
        options.forEach((o) => o.setAttribute('aria-selected', o === opt ? 'true' : 'false'));
        row.dataset.variantId = opt.dataset.id;
        const label = btn.querySelector('[data-vlabel]');
        if (label) label.textContent = opt.dataset.title;
        const img = row.querySelector('[data-vimg]');
        if (img && opt.dataset.img) img.src = opt.dataset.img;
        close(true);
        syncMainId();
      };

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (list.hidden) open();
        else close(false);
      });
      list.addEventListener('click', (e) => choose(e.target.closest('[role="option"]')));
      list.addEventListener('keydown', (e) => {
        const idx = options.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          (options[idx + 1] || options[0]).focus();
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          (options[idx - 1] || options[options.length - 1]).focus();
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          choose(document.activeElement.closest('[role="option"]'));
        } else if (e.key === 'Escape' || e.key === 'Tab') {
          close(e.key === 'Escape');
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-vsel]')) closeAllLists(root);
    });
    syncMainId();
  }

  function initAddToCart(root) {
    const form = root.querySelector('[data-rv-form]');
    const btn = root.querySelector('[data-atc]');
    const errorEl = root.querySelector('[data-error]');
    if (!form || !btn) return;

    const showError = (msg) => {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.hidden = !msg;
    };

    // Bấm Back từ checkout: trang lấy lại từ bfcache vẫn còn spinner
    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-disabled');
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-loading')) return;
      showError('');

      const bundle = root.querySelector('[data-bundle].is-selected');
      const rows = bundle ? Array.from(bundle.querySelectorAll('[data-variant-row]')) : [];
      const counts = new Map();
      rows.forEach((r) => {
        const id = r.dataset.variantId;
        if (id) counts.set(id, (counts.get(id) || 0) + 1);
      });
      if (counts.size === 0) {
        const fallback = form.querySelector('[data-main-id]');
        if (fallback && fallback.value) counts.set(fallback.value, parseInt(bundle && bundle.dataset.qty, 10) || 1);
      }
      const items = Array.from(counts, ([id, quantity]) => ({ id: Number(id), quantity }));
      if (items.length === 0) return;

      btn.classList.add('is-loading');
      btn.setAttribute('aria-disabled', 'true');
      const stopLoading = () => {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      };
      try {
        const addUrl = (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
        const res = await fetch(addUrl.replace(/\.js\.js$/, '.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items }),
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          showError(data.description || data.message || 'Could not add to cart.');
          stopLoading();
          return;
        }
        // Thêm giỏ xong chuyển thẳng tới checkout (giữ spinner tới khi rời trang)
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        window.location.href = rootUrl + 'checkout';
      } catch (err) {
        console.error(err);
        showError('Could not add to cart. Please try again.');
        stopLoading();
      }
    });
  }

  function initAccordion(root) {
    const wrap = root.querySelector('[data-accordion]');
    if (!wrap) return;
    wrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-faq-btn]');
      if (!btn) return;
      const item = btn.closest('.rv-pdp__faq-item');
      const willOpen = !item.classList.contains('is-open');
      wrap.querySelectorAll('.rv-pdp__faq-item').forEach((it) => {
        const open = it === item && willOpen;
        it.classList.toggle('is-open', open);
        const b = it.querySelector('[data-faq-btn]');
        const panel = it.querySelector('.rv-pdp__faq-a');
        if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (panel) panel.hidden = !open;
      });
    });
  }

  function initScrollLinks(root) {
    root.querySelectorAll('[data-scroll-link]').forEach((a) => {
      a.addEventListener('click', (e) => {
        const href = a.getAttribute('href') || '';
        if (!href.startsWith('#') || href.length < 2) return;
        const target = document.getElementById(href.slice(1));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function initEstimate(root) {
    const el = root.querySelector('[data-est-date]');
    if (!el || el.dataset.fixed) return;
    const days = parseInt(el.dataset.days, 10) || 0;
    const d = new Date();
    d.setDate(d.getDate() + days);
    const day = d.getDate();
    const mod100 = day % 100;
    const mod10 = day % 10;
    let suffix = 'th';
    if (mod100 < 11 || mod100 > 13) {
      if (mod10 === 1) suffix = 'st';
      else if (mod10 === 2) suffix = 'nd';
      else if (mod10 === 3) suffix = 'rd';
    }
    const month = d.toLocaleString('en-US', { month: 'long' });
    el.textContent = month + ' ' + day + suffix;
  }

  function init(root) {
    if (!root || root.dataset.rvReady) return;
    root.dataset.rvReady = 'true';
    initGallery(root);
    initBundles(root);
    initAddToCart(root);
    initAccordion(root);
    initScrollLinks(root);
    initEstimate(root);
  }

  const initAll = () => document.querySelectorAll('[data-rv-pdp]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-rv-pdp]');
    if (root) init(root);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const bundle = e.target.closest && e.target.closest('[data-bundle]');
    if (bundle) {
      const radio = bundle.querySelector('input[type="radio"]');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
})();
